import { graphql } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useCreateConsultationReportMutation as useCreateConsultationReportMutationType } from "@/modules/patients/detail/consultation-report/services/__generated__/useCreateConsultationReportMutation.graphql"

const createConsultationReportMutation = graphql`
  mutation useCreateConsultationReportMutation($input: Ch_createConsultationReportInput!) {
    ch_createConsultationReport(input: $input) {
      ch_ConsultationReport {
        id
        progressNoteId
        patientId
        createdAt
        createdBy
        updatedAt
        updatedBy
        fileId
        signedAt
        concludedAt
        concludedBy
        language
        healthcareProviderId
        diagnosisCode
        anamnesis
        recommendedTreatment
        isAiGenerated
        isAiContentModified
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
      }
      errors {
        ... on PatientIdIsRequired {
          message
        }
        ... on DocumentAlreadyExists {
          message
        }
        ... on FieldLengthInvalid {
          message
        }
        ... on ConsultationReportCareProviderNotFound {
          message
        }
      }
    }
  }
`

const useCreateConsultationReportMutation = () => {
  return useMutationWithErrorDialog<useCreateConsultationReportMutationType>(createConsultationReportMutation)
}

export { useCreateConsultationReportMutation }
